import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { GetSupportCommentsByTicketResponse } from "@src/types/support";

export const getSupportCommentsByTicketWithLanguage = async (
  namespace: string,
  ticketId: string,
  language: string,
): Promise<GetSupportCommentsByTicketResponse> => {
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetSupportCommentsByTicketResponse>(
      `${url}/api/v1/ns/${namespace}/tickets/${ticketId}/comments?language=${language}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch support comments. Please try again later.",
      );
    }

    throw new Error("An unexpected error occurred while fetching comments.");
  }
};
